import { useEffect, useState } from "react";
import { requestLastPersonalGoalWinners } from "@/apps/goals/services/goalsApi";
import { useGoalsStore } from "@/apps/goals/store/goalsStore";
import { GoalWinner } from "@/apps/goals/types";

export const useGoalWinners = () => {
  const programConfigId = useGoalsStore((state) => state.initData?.program.id);
  const [winners, setWinners] = useState<GoalWinner[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (programConfigId == null) {
      setWinners([]);
      setIsLoading(false);
      return;
    }

    let ignoreResult = false;
    setIsLoading(true);

    requestLastPersonalGoalWinners(programConfigId)
      .then((nextWinners) => {
        if (ignoreResult) return;

        setWinners(nextWinners);
        setIsLoading(false);
      })
      .catch(() => {
        if (ignoreResult) return;

        setWinners([]);
        setIsLoading(false);
      });

    return () => {
      ignoreResult = true;
    };
  }, [programConfigId]);

  return { winners, isLoading };
};
